import type { ReactNode } from 'react';
import { ErrorState } from '../../../media/shared/ErrorState.js';
import type { CreativeDetailScope } from '../data/api.js';
import { useSingleCreativeTags } from '../data/api.js';
import { SectionSkeleton } from '../shared/SectionSkeleton.js';
import { TagsPanel } from './TagsPanel.js';

interface TagsTabProps {
  scope: CreativeDetailScope;
  creativeId: string;
}

export function TagsTab({ scope, creativeId }: TagsTabProps): ReactNode {
  const tags = useSingleCreativeTags({ ...scope, creativeId }, true);

  if (tags.isError) return <ErrorState />;
  if (tags.data === undefined) return <SectionSkeleton variant="table" />;

  const data = tags.data;
  return (
    <TagsPanel
      categories={data.categories}
      tagCount={data.tagCount}
      durationSeconds={data.durationSeconds}
      isVideo={data.creativeType?.toUpperCase() === 'VIDEO'}
    />
  );
}
